module.exports = __webpack_public_path__ + "img/644bae3f8ee5218b253d08e0c5ebcc78.png";